import img1 from './laserove-beleni-zubu_1.jpg';
import img2 from './laserove-beleni-zubu_2.jpg';
import img3 from './laserove-beleni-zubu_3.jpg';
import img4 from './laserove-beleni-zubu_4.jpg';
import img5 from './laserove-beleni-zubu_5.jpg';
import img6 from './laserove-beleni-zubu_6.jpg';

export default {
    "laserove-beleni-zubu": [img1, img2, img3, img4, img5, img6]
}


// WEBPACK FOOTER //
// ./src/assets/img/llc/special/index.js